import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TrainingCategoryData } from '../training-category'

export interface TrainingListData extends ConvertedComponentData {
  categories?: TrainingCategoryData[];
  backgroundColor?: string;
}

export const TRAINING_LIST_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingListData>[]>('TrainingListConverter')
